<template>
  <section class="tf-card">
    <div class="tf-card__head">
      <span class="tf-card__icon"><i class="fa fa-rocket"></i></span>
      <div class="tf-card__titles">
        <h3 class="tf-card__title">Релизы</h3>
        <p class="tf-card__sub">
          Каждый релиз сравнивается с предыдущим, на котором хватило замеров
        </p>
      </div>
    </div>
    <div class="tf-card__body">
      <div v-if="!rows.length" class="an-empty">
        <i class="fa fa-rocket"></i>
        <span>За период релизов не было</span>
      </div>
      <div v-else class="an-table-wrap">
        <table class="an-table">
          <thead>
          <tr>
            <th>Релиз</th>
            <th>Вердикт</th>
            <th class="an-num">Просмотры</th>
            <th v-for="metric in metrics" :key="metric" class="an-num" :title="metricText[metric].hint">
              {{ metricText[metric].name }}
            </th>
            <th>Где изменилось сильнее всего</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in rows" :key="row.rel">
            <td>
              {{ row.label }}
              <span class="an-cell-sub">с {{ formatDateTime(row.firstSeen) }}</span>
            </td>
            <td>
              <span class="tf-badge" :class="verdict(row).badge">{{ verdict(row).text }}</span>
            </td>
            <td class="an-num">{{ formatCount(row.views) }}</td>
            <td v-for="metric in metrics" :key="metric" class="an-num">
              {{ formatMetric(metric, row.metrics[metric] && row.metrics[metric].p75) }}
              <span v-if="change(row, metric)" class="an-cell-sub an-change"
                    :class="'an-change--' + change(row, metric).direction">
                {{ change(row, metric).text }}
              </span>
            </td>
            <td>
              <span v-if="!row.routeChanges || !row.routeChanges.length" class="an-cell-sub">—</span>
              <span v-for="rc in (row.routeChanges || []).slice(0, 3)" :key="rc.route + rc.metric" class="an-cell-sub">
                {{ rc.label }}: {{ metricText[rc.metric].name.toLowerCase() }}
                <span class="an-change" :class="'an-change--' + rc.change.direction">
                  {{ formatChange(rc.change) && formatChange(rc.change).text }}
                </span>
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import {
  RUM_METRICS,
  METRIC_TEXT,
  RELEASE_VERDICT,
  formatMetric,
  formatCount,
  formatChange,
  formatDateTime,
} from "@/common/rumFormat";

export default {
  name: "RumReleases",
  props: {
    data: {type: Object, required: true},
  },
  data() {
    return {metrics: RUM_METRICS, metricText: METRIC_TEXT}
  },
  computed: {
    // Сайт отдаёт релизы от свежего к старому.
    rows() {
      return this.data.rows || []
    },
  },
  methods: {
    formatMetric,
    formatCount,
    formatChange,
    formatDateTime,
    verdict(row) {
      return RELEASE_VERDICT[row.verdict] || RELEASE_VERDICT['not-enough']
    },
    change(row, metric) {
      return row.changes ? formatChange(row.changes[metric]) : null
    },
  },
}
</script>
